<app-dialog-close-button class="close-button" [compact]="true" (closed)="close()"></app-dialog-close-button>
 <h2 vng-dialog-title class="text-center">
    Are you sure you want to do this?
 </h2>

<div class="text-center mb-small">
    If you do this, any FlyMSG that violates the {{planDowngradedTo}} plan will lose all the formatting. The only way to get it back would be to upgrade again.
</div>

 <vng-dialog-actions align="center" class="top-space mb-small" style="display:flex; justify-content:center; align-items:center; gap:15px">

    <!--HubSpot Call-to-Action Code -->
    <span class="hs-cta-wrapper" id="hs-cta-wrapper-9df91c99-90bc-45de-ac7e-ce0ae6720d23" *ngIf="starterToFreemium()">
        <span class="hs-cta-node hs-cta-9df91c99-90bc-45de-ac7e-ce0ae6720d23" id="hs-cta-9df91c99-90bc-45de-ac7e-ce0ae6720d23">
            <!--[if lte IE 8]><div id="hs-cta-ie-element"></div><![endif]-->
            <button id="hs-cta-img-9df91c99-90bc-45de-ac7e-ce0ae6720d23" (click)="downgradePlan()" vng-button variant="primary">
                Downgrade to {{planDowngradedTo}}
            </button>
        </span>
    </span>

    <span class="hs-cta-wrapper" id="hs-cta-wrapper-13694406-1b42-4be1-a4b8-029dff8be67f" *ngIf="growthToFreemium()">
        <span class="hs-cta-node hs-cta-13694406-1b42-4be1-a4b8-029dff8be67f" id="hs-cta-13694406-1b42-4be1-a4b8-029dff8be67f">
            <!--[if lte IE 8]><div id="hs-cta-ie-element"></div><![endif]-->
            <button id="hs-cta-img-13694406-1b42-4be1-a4b8-029dff8be67f" (click)="downgradePlan()" vng-button variant="primary">
                Downgrade to {{planDowngradedTo}}
            </button>
        </span>
    </span>

    <span class="hs-cta-wrapper" id="hs-cta-wrapper-bbd68424-f774-465e-a40a-b3fdb2e09584" *ngIf="growthToStarter()">
        <span class="hs-cta-node hs-cta-bbd68424-f774-465e-a40a-b3fdb2e09584" id="hs-cta-bbd68424-f774-465e-a40a-b3fdb2e09584">
            <!--[if lte IE 8]><div id="hs-cta-ie-element"></div><![endif]-->
            <button id="hs-cta-img-bbd68424-f774-465e-a40a-b3fdb2e09584" (click)="downgradePlan()" vng-button variant="primary">
                Downgrade to {{planDowngradedTo}}
            </button>
        </span>
    </span>
    <!-- end HubSpot Call-to-Action Code -->
 </vng-dialog-actions>
